document.addEventListener('DOMContentLoaded', function () {
  const swiperElements = document.querySelectorAll('.category-cards__swiper');
  const DESKTOP_MQ = window.matchMedia('(min-width: 1280px)');

  for (const swiperEl of swiperElements) {
    const desktopSlider = swiperEl.dataset.desktopSlider === 'true';
    let swiper = null;

    function getSlideCount() {
      return swiperEl.querySelectorAll('.swiper-slide').length;
    }

    function isDesktopGrid() {
      return DESKTOP_MQ.matches && !desktopSlider;
    }

    function resetSlideStyles() {
      for (const slide of swiperEl.querySelectorAll('.swiper-slide')) {
        slide.removeAttribute('style');
      }
    }

    function applyDesktopGrid() {
      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      const slideCount = getSlideCount();

      if (!wrapper || slideCount === 0) {
        return;
      }

      swiperEl.classList.add('category-cards__swiper--static-grid');
      swiperEl.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-vertical', 'swiper-backface-hidden');

      wrapper.removeAttribute('style');
      resetSlideStyles();

      wrapper.style.display = 'grid';
      wrapper.style.gridTemplateColumns = 'repeat(' + slideCount + ', minmax(0, 1fr))';
      wrapper.style.gap = '28px';
      wrapper.style.transform = 'none';
      wrapper.style.height = 'auto';
      wrapper.style.width = '100%';
    }

    function clearDesktopGrid() {
      const wrapper = swiperEl.querySelector('.swiper-wrapper');

      swiperEl.classList.remove('category-cards__swiper--static-grid');

      if (wrapper) {
        wrapper.removeAttribute('style');
      }

      resetSlideStyles();
    }

    function destroySwiper() {
      if (!swiper) {
        return;
      }

      swiper.destroy(true, true);
      swiper = null;
      clearDesktopGrid();
    }

    function buildSwiperConfig() {
      const a11y = {
        enabled: true,
        prevSlideMessage: 'Previous category',
        nextSlideMessage: 'Next category',
        firstSlideMessage: 'This is the first category',
        lastSlideMessage: 'This is the last category',
        paginationBulletMessage: 'Go to category',
      };

      if (desktopSlider && DESKTOP_MQ.matches) {
        return {
          slidesPerView: 'auto',
          spaceBetween: 28,
          loop: false,
          centerInsufficientSlides: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          a11y,
        };
      }

      return {
        slidesPerView: 1.4,
        spaceBetween: 28,
        loop: false,
        centerInsufficientSlides: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y,
        breakpoints: {
          560: {
            slidesPerView: 2.5,
            spaceBetween: 28,
          },
          768: {
            slidesPerView: 3.5,
            spaceBetween: 28,
          },
          992: {
            slidesPerView: 4.5,
            spaceBetween: 28,
          },
        },
      };
    }

    function initSwiper() {
      if (swiper) {
        return;
      }

      clearDesktopGrid();
      swiper = new Swiper(swiperEl, buildSwiperConfig());
    }

    function updateLayout() {
      if (isDesktopGrid()) {
        destroySwiper();
        applyDesktopGrid();
        return;
      }

      clearDesktopGrid();
      initSwiper();
    }

    updateLayout();

    DESKTOP_MQ.addEventListener('change', updateLayout);
  }
});
